import { filter } from 'rxjs/operators';
import { isNil } from 'lodash-es';
import { Observable } from 'rxjs';

/** This will ensure that a give stream is not nil */
export default function isNotNil<T>() {
  return (source: Observable<T>) => {
    return source.pipe(
      filter(value => !isNil(value))
    );
  };
}
